webpackJsonp([217194390982654],{

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.AlbanyImageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(12);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _HeroSmall = __webpack_require__(8);
	
	var _HeroSmall2 = _interopRequireDefault(_HeroSmall);
	
	var _LocationMicroNav = __webpack_require__(10);
	
	var _LocationMicroNav2 = _interopRequireDefault(_LocationMicroNav);
	
	var _LocationContent = __webpack_require__(9);
	
	var _LocationContent2 = _interopRequireDefault(_LocationContent);
	
	var _LocationRelated = __webpack_require__(11);
	
	var _LocationRelated2 = _interopRequireDefault(_LocationRelated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AlbanyLocation = function (_React$Component) {
	  _inherits(AlbanyLocation, _React$Component);
	
	  function AlbanyLocation() {
	    _classCallCheck(this, AlbanyLocation);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  AlbanyLocation.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_HeroSmall2.default, { location: 'Albany, NY' }),
	      _react2.default.createElement(_LocationMicroNav2.default, null),
	      _react2.default.createElement(_LocationContent2.default, {
	        category: 'E-bikes',
	        title: 'Empire State of Mind',
	        story: 'At the New York Bicycling Coalition Annual Summit we provided an update on national, state and New York City e-bike policies to a group of 100 advocates, government staff, and business leaders. PeopleForBikes has been building a broad coalition of supporters as we work to pass a three-class e-bike bill in New York state. This event helped explain how New York stakeholders can play a role.'
	      }),
	      _react2.default.createElement(_gatsbyImage2.default, {
	        title: 'Albany',
	        alt: 'NY Bicycling Coalition logo',
	        sizes: this.props.data.albanyImage.sizes
	      }),
	      _react2.default.createElement(_LocationRelated2.default, {
	        prevLocationName: 'Arizona',
	        prevLocationPath: 'arizona',
	        prevLocationImgPath: this.props.data.albanyPrevImage,
	        nextLocationName: 'Park City, UT',
	        nextLocationPath: 'park-city',
	        nextLocationImgPath: this.props.data.albanyNextImage
	      })
	    );
	  };
	
	  return AlbanyLocation;
	}(_react2.default.Component);
	
	exports.default = AlbanyLocation;
	
	// GraphQL query
	
	var AlbanyImageQuery = exports.AlbanyImageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-albany-js-ae3df7c84f580730beb6.js